<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript">
				<p class="steps_count">2/8</p>
                <span class="steps_bolder_words">어떤 종류</span>의 술을<br/>
                <span class="steps_bolder_words">몇 잔</span>정도 마시나요? (1일 기준)
			</v-col>
		</v-row>
		<v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="center" align="center" class="avatar">
                <img :src="getAvatarImage" class="avatar-img">
			</v-col>
		</v-row>
		<v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="center" align="center"> 
				<p class="steps_bolder_words ma-0"> 종류 </p>
			</v-col>
			<v-col cols="12" align-self="center" align="center">
				<button
					class="img-cell"
					tabindex="1"
					:class="drnkType === 1 ? 'selected' : ''"
					@click="select(1)"
				>
					<img
						:src="getImage(1)"
						class="icon-img"
						alt="맥주"
					>
					<br/>
					맥주
				</button>
				<button
					class="img-cell"
					tabindex="2"
					:class="drnkType === 2 ? 'selected' : ''"
					@click="select(2)"
				>
					<img
						:src="getImage(2)"
						class="icon-img"
						alt="소주"
					>
					<br/>
					소주
				</button>
				<button
					class="img-cell"
					tabindex="3"
					:class="drnkType === 3 ? 'selected' : ''"
					@click="select(3)"
				>
					<img
						:src="getImage(3)"
						class="icon-img"
						alt="와인"
					>
					<br/>
					와인
				</button>
				<button
					class="img-cell"
					tabindex="4"
					:class="drnkType === 4 ? 'selected' : ''"
					@click="select(4)"
				>
					<img
						:src="getImage(4)"
						class="icon-img"
						alt="양주"
					>
					<br/>
					양주
				</button>
			</v-col>
		</v-row>
		<v-row dense class="pa-0 ma-0">
			<v-col cols="12" align-self="end" align="center" class="pa-0 ma-0"> 
				<p class="steps_bolder_words ma-0"> 잔수 </p>
			</v-col>
			<v-col cols="12" align-self="end" align="left" class="pa-0 ma-0 drnk-layer">
				<slide-picker
					ref="picker"
					suffix="잔"
					:tab-index="6"
					:items="drinkAmountList"
					:initial-index="0"
					@value="changeValue"
				/>
			</v-col>
		</v-row>

        <v-container class="pa-0 ma-0 mt-16 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="disabledBtn ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						:disabled="!disabledBtn"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
import SlidePicker from '../../components/SlidePicker';

export default {
    components: {SlidePicker},
    data () {
        return {
            enableButton: false,
            drnkQty: 1,
            drnkType: 0,
            drinkAmountList: Array.range(1, 101),
        }
    },
	computed: {
		...mapGetters("survey", {
			checkUp: "checkUp"
		}),
		getAvatarImage() {
			switch(this.drnkType) {
				case 1: return require('@/assets/images/avatar-drinking-beer.png')
				case 2: return require('@/assets/images/avatar-drinking-soju.png')
				case 3: return require('@/assets/images/avatar-drinking-wine.png')
				case 4: return require('@/assets/images/avatar-drinking-liquor.png')
				default: return require('@/assets/images/avatar-drinking-default.png')
			}
		},
		disabledBtn() {
			if (this.drnkType > 0) {
				return true
			} else {
				return false
			}
		}
	},

	methods: {
		...mapActions("survey", ["setCheckupTemp", "setStep"]),
		getImage(selected) {
			if(this.drnkType === selected) {
				switch(selected) {
					case 1: return require('@/assets/images/ico-drinking-beer-s.png')
					case 2: return require('@/assets/images/ico-drinking-soju-s.png')
					case 3: return require('@/assets/images/ico-drinking-wine-s.png')
					case 4: return require('@/assets/images/ico-drinking-liquor-s.png')
				}
			}
			else {
				switch(selected) {
					case 1: return require('@/assets/images/ico-drinking-beer-n.png')
					case 2: return require('@/assets/images/ico-drinking-soju-n.png')
					case 3: return require('@/assets/images/ico-drinking-wine-n.png')
					case 4: return require('@/assets/images/ico-drinking-liquor-n.png')
				}
			}
		},
		select(num) {
			this.drnkType = num;
		},

		//이전
		previous() {
			this.setStep(5)
			this.$router.push("/checkup/step5");
		},
		//다음
		next() {
			const params = {
				step: 51,
				drnkType: this.drnkType,
				drnkQty: this.drnkQty
			};
			this.setCheckupTemp(params);
			this.setStep(6)
			this.$router.push("/checkup/step6");
        },
        changeValue ({ value }) {
		    this.drnkQty = value
		},
		async restoreData() {
            await this.$nextTick()
			if(this.checkUp.drnkType || this.checkUp.drnkQty) {
				this.drnkType = this.checkUp.drnkType
				this.drnkQty = this.checkUp.drnkQty - 1
				this.$refs.picker.setPosition(this.drnkQty)
			}
		}
    },
	mounted() {
		window.scrollTo(0, 0)
		this.setStep(5)
		this.restoreData()
	}
};
</script>

<style scoped>
	.title {
        min-height: 20vh;
        margin-bottom: 0px;
    }
	.avatar {
		text-align: center;
    }
    .avatar-img {
        width: 94px;
    }
    .input-list {
        margin-bottom: 8vmax;
        position: relative;
        width: 100%;
    }
	.input-wrapper {
		width: 100%;
		text-align: left;
	}
	.input-item-wrapper {
        width: 100%;
        position: relative;
		display: inline-block;
	}
	.input-item {
		display: inline-block;
		text-align: right;
		vertical-align: middle;
		width: 12vmin;
		height: 9vmax;
		line-height: 9vmax;
	}
	.input-value {
        width: 100%;
		display: inline-block;
		text-align: center;
	}
	.input-value.slider {
        vertical-align: middle;
	}
	.img-cell {
		display: inline-block;
		background-color: transparent;
		width: 7.8vh;
        padding: 1vh;
		text-align: center;
		border-radius: 3vh;
		vertical-align: middle;
        color: #8f8f8f;
        font-size: 2vmax;
		font-weight: normal;
	}
	.img-cell.selected {
		background-color: #3f6fff;
		color: white;
		font-weight: bold;
	}
	.icon-img {
		display: inline-block;
		height: 5vmax;
	}
	.drnk-layer {
		display: inline-block;
		height: 7vh;
		box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.1), inset 3px 3px 5px 0 rgba(255, 255, 255, 0.5);
		background-image: radial-gradient(circle at 50% 50%, #ffffff, #ffffff 68%, #eaeaea 100%);
    }

    @media all and (max-height: 567px) {
        .title {
            font-size: 5vw;
        }
        .sub-style {
            font-size: 9vw;
        }
    }

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }
	::v-deep .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
		background-color: #e6e8ee !important;
	}

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
	
    ::v-deep button:disabled,
	button[disabled] {
		color: #ffffff !important;
		border: solid 0 #a7bdff !important;
	}
</style>
